module.exports = {
          srcSet: __webpack_public_path__ + "0ebb9c20e33084848cc0a1709aeba1fd-160.png"+" 160w",
          images:[ {path: __webpack_public_path__ + "0ebb9c20e33084848cc0a1709aeba1fd-160.png",width: 160,height: 100}],
          src: __webpack_public_path__ + "0ebb9c20e33084848cc0a1709aeba1fd-160.png",
          toString:function(){return __webpack_public_path__ + "0ebb9c20e33084848cc0a1709aeba1fd-160.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAaElEQVR4nI3KQQqCcBTE4a+EREiIcNMVvIaLoFZ6gLpHgReIlm5dtPWS8eAfLgTpB4+ZeTOwwRaZmcjx//kFxVqu0eKCW/INrnjjjlMMO0z44IUeTwx4YMQ5hjtUOKQrkeOIfepC/+ML6VgIyH79PssAAAAASUVORK5CYII=",
          width: 160,
          height: 100
        }